'use strict'

module.exports = function (array, key, options) {
  if (!array || !key) return {}

  options = options || {}
  var arraify = options.arraify
  var overwrite = options.overwrite

  var output = {}

  array.forEach(function (element) {
    if (element[key]) {
      if (output[element[key]]) {
        if (arraify) {
          output[element[key]].push(element)
        } else {
          if (overwrite) output[element[key]] = element
        }
      } else {
        output[element[key]] = arraify ? [element] : element
      }
    }
  })

  return output
}
